import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { IResourceProvider } from 'common/resourceprovider';

export enum WorkItemChangedDialogMode {
    Generic,
    DialogSpecific
}

export class WorkItemChangedDialog implements IDialog {
    private dialogContent: JQuery;
    options: IDialogOptions;

    constructor(mode: WorkItemChangedDialogMode, closeAction: () => void, resources: IResourceProvider, additionalMessage?: string) {
        this.dialogContent = $('<div />').css('margin', '10px').append(
            $('<div />').text(resources.getCoreString(mode === WorkItemChangedDialogMode.DialogSpecific ? 'MsgWorkItemChangedDialogGenericMessage' : 'MsgWorkItemChangedDialogMessage'))
        );
        if (additionalMessage !== undefined && additionalMessage !== null) {
            this.dialogContent.append($('<div />').text(additionalMessage));
        }

        this.options = {
            title: resources.getCoreString('MsgWorkItemChanged'),
            width: 525,
            height: 275,
            dialogClass: 'wf-dialog',
            buttons: [
                { text: resources.getCoreString('XamlClose'), click: () => this.dialogContent.dialog('close') }
            ],
            close: closeAction
        };
    }

    content(): JQuery {
        return this.dialogContent;
    }
}